import { registerDecorator, ValidationArguments, ValidationOptions, ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";
import addressRules from "../../assets/data/address_rules.json";
import * as countryCodes from "country-codes-list";

const allCountries = countryCodes.customArray({
    countryCallingCode: "+{countryCallingCode}",
    countryName: "{countryNameEn}",
    countryCode: "{countryCode}",
    flag: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{countryCode}.svg"
}).map((f) => ({ ...f, flag: f["flag"] }));

@ValidatorConstraint({ name: "AddressConstraint", async: false })
export class AddressValidatorConstraint implements ValidatorConstraintInterface {
    validate(value: any, args: ValidationArguments) {
        const addressCountry = String((args.object as any).address_country || "").trim().toUpperCase();
        const property = String(args.constraints?.[0] || args.property || "");
        const selectedCountry = allCountries.find(
            (country: any) => String(country?.countryName || "").trim().toUpperCase() === addressCountry
        ) as any;
        const countryCode = String(selectedCountry?.countryCode || "").trim().toUpperCase();
        const countryRule = (addressRules as Record<string, any>)[countryCode];

        const fieldMap: Record<string, string> = {
            line1: "addressLine1",
            line2: "addressLine2",
            postcode: "postcode",
            state: "state",
            city: "city",
        };

        const ruleField = fieldMap[property];
        if (!ruleField) {
            return true;
        }

        if (!countryRule || !countryRule.fields) {
            return true;
        }

        if (countryRule.fields[ruleField] !== true) {
            return true;
        }

        return String(value || "").trim() !== "";
    }

    defaultMessage(args: ValidationArguments) {
        const property = String(args.constraints?.[0] || args.property || "");
        const messageMap: Record<string, string> = {
            line1: "validation.address_line_1_should_not_be_empty",
            line2: "validation.address_line_2_should_not_be_empty",
            postcode: "validation.postcode_should_not_be_empty",
            state: "validation.state_should_not_be_empty",
            city: "validation.city_should_not_be_empty",
        };

        return messageMap[property] || "validation.address_line_1_should_not_be_empty";
    }
}

export function AddressValidator(field: "line1" | "line2" | "postcode" | "state" | "city", validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: "AddressValidator",
            target: object.constructor,
            propertyName,
            constraints: [field],
            options: validationOptions,
            validator: AddressValidatorConstraint,
        });
    };
}
